function _s(o,i,p,l){void 0===i&&(i=400),void 0===l&&(l=!1),o.style.overflow="hidden",l&&(o.style.display="block");var n,t=window.getComputedStyle(o),s=parseFloat(t.getPropertyValue("height")),a=parseFloat(t.getPropertyValue("padding-top")),r=parseFloat(t.getPropertyValue("padding-bottom")),y=parseFloat(t.getPropertyValue("margin-top")),d=parseFloat(t.getPropertyValue("margin-bottom")),g=s/i,m=a/i,h=r/i,u=y/i,x=d/i;window.requestAnimationFrame(function t(e){void 0===n&&(n=e);e-=n;l?(o.style.height=g*e+"px",o.style.paddingTop=m*e+"px",o.style.paddingBottom=h*e+"px",o.style.marginTop=u*e+"px",o.style.marginBottom=x*e+"px"):(o.style.height=s-g*e+"px",o.style.paddingTop=a-m*e+"px",o.style.paddingBottom=r-h*e+"px",o.style.marginTop=y-u*e+"px",o.style.marginBottom=d-x*e+"px"),i<=e?(o.style.height="",o.style.paddingTop="",o.style.paddingBottom="",o.style.marginTop="",o.style.marginBottom="",o.style.overflow="",l||(o.style.display="none"),"function"==typeof p&&p()):window.requestAnimationFrame(t)})}HTMLElement.prototype.slideToggle=function(t,e){0===this.clientHeight?_s(this,t,e,!0):_s(this,t,e)},HTMLElement.prototype.slideUp=function(t,e){_s(this,t,e)},HTMLElement.prototype.slideDown=function(t,e){_s(this,t,e,!0)};

function findUrlParams(parameterName) {
    var res = null, tmp = [];
    location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) {
          res = decodeURIComponent(tmp[1]);
      }
    });
    return res;
}

class FaqDropwdown extends HTMLElement {
    constructor() {
      super();
      
      this.dropdown = this.querySelector('.faq-dropwdown');
      this.dropdown_opened = false;
      this.dropdown_container = this.querySelector('.faq-dropwdown__container');
      this.body = document.querySelector('body');
      this._initEventListener();
    }

    _initEventListener() {
        this.dropdown.addEventListener('click', this._toggleDropdown.bind(this));
        const onClickOutside = (e) => {
            if (!(e.composedPath().includes(this.dropdown))) {
                if (this.dropdown_opened) {
                    this._toggleDropdown();
                }
            }
        }
        window.addEventListener('click', onClickOutside.bind(this));
    }

    _toggleDropdown() {
        this.body.classList.toggle('overflow-hidden');
        this.dropdown_container.scrollTo(0, 1000);
        this.dropdown.classList.toggle('opened');
        this.dropdown_opened = this.dropdown.classList.contains('opened') ? true : false;
    }

}
  
customElements.define('faq-dropdown', FaqDropwdown);
  
class FaqCategory extends HTMLElement {
    constructor() {
        super();
        this.questions = this.querySelectorAll('.faq-category__question');
        this.responses = this.querySelectorAll('.faq-category__response');
        this.questions.forEach((elem) => {
            elem.addEventListener('click', this._toggleResponse.bind(this));
        });
        this._openResponsesParams();
        console.dir(this.questions);
    }

    _hideAllResponses() {
        this.responses.forEach((elem) => {
            elem.closest('[data-element-id]').classList.remove('actif');
            elem.style.display = "none";
        })
    }

    _openResponsesParams() {
        var id = findUrlParams('id');
        if (id) {
            this.querySelector(`[data-element-id="${id}"] .faq-category__question`).click();
        }
    }

    _toggleResponse(e) {
        var elem = e.currentTarget.closest('[data-element-id]').querySelector('.faq-category__response');
        if (elem.closest('[data-element-id]').classList.contains('actif')) {
            elem.closest('[data-element-id]').classList.remove('actif');
            elem.slideUp(250);
        } else {
            elem.closest('[data-element-id]').classList.add('actif');
            elem.slideDown(250)
        }
    }
}

customElements.define('faq-category', FaqCategory);
